export class ReportGenerateDataRequest {
    startDate: Date;
    endDate: Date;
    tutorId: number;
    clientId: number;
    coordinatorId: number;
    studentId: number;
    reportTypeId: number;
    createdBy: number;
    reportTypes: number[];
    clientIds: number[];
    userId: number;
    placementId: number;
    studentName: string;
    referrerEmail: string;
    /** Brands to restrict to; empty or absent means every brand the user may see. */
    companyIds?: number[];

    constructor() {}
}